__turbopack_context__.v({
  "main_content": "layout-module-scss-module__mXfxVq__main_content",
  "nav_position": "layout-module-scss-module__mXfxVq__nav_position",
  "scroll_hidden": "layout-module-scss-module__mXfxVq__scroll_hidden",
});
